(function () {
  'use strict';
  const nav = document.querySelector('.category-nav .wrap');
  const active = nav?.querySelector('[aria-current=page]');
  if (active && nav.scrollWidth > nav.clientWidth) nav.scrollLeft = Math.max(0, active.offsetLeft - nav.offsetLeft - 24);
  const comparisons = [...document.querySelectorAll('.table-scroll')];
  const updateOverflow = () => comparisons.forEach(region => {
    const overflow = region.scrollWidth > region.clientWidth + 2;
    const hint = region.previousElementSibling;
    if (hint?.classList.contains('table-hint')) hint.hidden = !overflow;
    region.classList.toggle('has-overflow', overflow);
    region.classList.toggle('at-end', region.scrollLeft >= region.scrollWidth-region.clientWidth-2);
  });
  comparisons.forEach(region => region.addEventListener('scroll', updateOverflow, {passive:true}));
  window.addEventListener('resize', updateOverflow);
  const picker = document.querySelector('[data-backdrop-compare]');
  if (picker) {
    const table = document.querySelector('#backdrop-comparison');
    table.classList.add('mobile-product-comparison');
    const choose = () => {
      table.querySelectorAll('tr').forEach(row => [...row.children].forEach((cell,index) => cell.classList.toggle('mobile-selected',index===0||index===Number(picker.value))));
      updateOverflow();
    };
    picker.closest('[data-enhanced]').hidden = false;
    picker.addEventListener('change',choose);choose();
  }
  updateOverflow();
})();
